module.exports = __webpack_public_path__ + "img/qian-1.14168224.svg";